import axios from "axios";

const Service = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/`,
  headers: {
    Accept: "application/json",
  },
});

export default Service;
